// extracted by mini-css-extract-plugin
module.exports = {"plainText":"plainTextWrapper__plainText____1GRn"};